import React, { useEffect, useState } from 'react'
import ContactForm from '../components/ContactForm'
import { useTranslate } from '../components/TranslationText'
import axiosUmbraco from '../axios/axiosUmbraco';
import { RemovePlusFromString } from '../helper/RemovePlusFromString';
const pageID = process.env.REACT_APP_CONTACT_ID;

export default function ContactUs({ data, toast }) {
    const { translate } = useTranslate();
    const [contactDetails, setContactDetails] = useState({});

    async function getContactDetails() {
        try {
            const res = await axiosUmbraco.get(`/umbraco/delivery/api/v2/content/item/${pageID}`);
            const formattedData = {
                title: res?.data?.properties?.title ?? '',
                subtitle: res?.data?.properties?.subtitle ?? '',
                address: res?.data?.properties?.contactAddress ?? '',
                map: res?.data?.properties?.contactMap ?? '',
                email: res?.data?.properties?.contactEmail ?? '',
                phone: res?.data?.properties?.contactPhone ?? '',
            }
            setContactDetails(formattedData);
        } catch (error) {
            console.log('Error in getContactDetails', error);
        }
    }
    useEffect(() => {
        getContactDetails();
    }, [])

    return (
        <div className='row my-3'>
            <div className="col-lg-7 col-md-7 col-sm-12">
                <h3 className="NewsPostTitle bold" >{contactDetails?.title} </h3>
                <p className="Contact-US-Desc">{contactDetails?.subtitle}
                </p>
                <div className="contactUsLable">
                    <i className="fa fa-map-marker me-2"></i>
                    <span>{translate('web.address', 'Address')}</span>
                    <p>{contactDetails?.address}</p>
                    <div>
                        <iframe src={contactDetails?.map} width="100%" height="150" style={{ border: 0 }} allowfullscreen={true} loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
                <a className="contactUsLable" href={`mailto:${contactDetails?.email}`}>
                    <i className="fa fa-envelope me-2"></i>
                    <span>{translate('web.email', 'Email')}</span>
                    <p>{contactDetails?.email}</p>
                </a>
                {contactDetails?.phone &&
                    <a className="contactUsLable" href={`tel:${contactDetails?.phone}`}>
                        <i className="fa fa-phone me-2"></i>
                        <span className="roboto-regular">{translate('web.phone', 'Phone')}</span>
                        <p>{RemovePlusFromString(contactDetails?.phone)}</p>
                    </a>
                }
            </div>
            <div className='col-lg-5 col-md-5 col-sm-12'>
                <ContactForm key={'contactForm'} toast={toast} />
            </div>
        </div>

    )
}
